import _ from 'lodash';
import PropTypes from 'prop-types';

/**
 * @param {*} targetId  targetID | {id, type}
 */
const convertId = targetId => {
  const typeMap = {
    B: 'Background',
    C: 'CropMode',
    F: 'Frame',
    G: 'Grid',
    L: 'Line',
    P: 'Image',
    S: 'Shape',
    T: 'Text',
    V: 'Vector',
  };
  const targetIdType = {};
  let typeConfig = {};
  if (_.has(targetId, 'id')) {
    const letter = _.findKey(typeMap, function (type) {
      return type === targetId.type;
    });
    targetIdType.targetId = `${letter}_${targetId.id}`;
    targetIdType.id = targetId.id;
    targetIdType.type = targetId.type;
  } else {
    const id = parseInt(targetId.split('_')[1]);
    const type = typeMap[targetId.split('_')[0]];
    targetIdType.id = id;
    targetIdType.type = type;
    targetIdType.targetId = targetId;
  }

  switch (targetIdType.type) {
    case 'Text':
      typeConfig = {
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'e', 'se', 'sw', 'w'],
      };
      break;
    case 'Image':
      typeConfig = {
        config: {
          isResizable: true,
          isScalable: false,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
      };
      break;
    case 'Shape':
      typeConfig = {
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
      };
      break;
    case 'Grid':
      typeConfig = {
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
      break;
    case 'Line':
      typeConfig = {
        config: {
          isResizable: true,
          isScalable: false,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['e', 'w'],
      };
      break;
    case 'Vector':
      typeConfig = {
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
      break;
    case 'Frame':
      typeConfig = {
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
      break;
    case 'Group':
      typeConfig = {
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
      break;
    case 'Background':
    case 'ImageBackground':
    case 'VideoBackground':
      typeConfig = {
        config: {
          isResizable: false,
          isScalable: false,
          isRotatable: false,
          isDraggable: false,
        },
        renderDir: [],
      };
      break;
    case 'CropMode':
      typeConfig = {
        config: {
          isResizable: true,
          isScalable: false,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
      break;
  }
  return {
    id: targetIdType.id,
    type: targetIdType.type,
    targetId: targetIdType.targetId,
    moveableConfig: typeConfig.config,
    renderDir: typeConfig.renderDir,
  };
};

convertId.propTypes = {
  targetId: PropTypes.any,
};

/**
 * @param {*} el  HTML Element
 * @param {*} holder  Element Holder
 */
const getTransform = (el, holder) => {
  const currentTransform = {};
  if (el) {
    const style = window.getComputedStyle(el);
    // eslint-disable-next-line no-undef
    const matrix = new WebKitCSSMatrix(style.webkitTransform);
    const flipper = el.querySelector('.flipper');
    const flipStyle = _.get(flipper, 'style.transform');
    let flip = [1];
    if (flipStyle) {
      flip = flipStyle.replace(/[ .)(]|scale/g, '').split(',');
      if (flip.length === 1) {
        flip.push(flip[0]);
      }
    }

    const angle = Math.round(Math.atan2(matrix.b, matrix.a) * (180 / Math.PI));

    currentTransform.rotate = angle;
    currentTransform.tx = matrix.m41;
    currentTransform.ty = matrix.m42;
    currentTransform.tz = matrix.m43;
    currentTransform.flip = flip;
    if (currentTransform.tz === 0) currentTransform.tz = 5;
    currentTransform.sx = Math.sqrt(Math.pow(matrix.a, 2) + Math.pow(matrix.b, 2));
    currentTransform.sy = Math.sqrt(Math.pow(matrix.c, 2) + Math.pow(matrix.d, 2));
    currentTransform.w = el.offsetWidth;
    currentTransform.h = el.offsetHeight;
  }
  if (holder) {
    currentTransform.holder = {};
    const holderStyle = window.getComputedStyle(holder);
    // eslint-disable-next-line no-undef
    const holderMatrix = new WebKitCSSMatrix(holderStyle.webkitTransform);
    const holderAngle = Math.round(Math.atan2(holderMatrix.b, holderMatrix.a) * (180 / Math.PI));
    currentTransform.holder.rotate = holderAngle;
    currentTransform.holder.tx = holderMatrix.m41;
    currentTransform.holder.ty = holderMatrix.m42;
    currentTransform.holder.sx = Math.sqrt(
      Math.pow(holderMatrix.a, 2) + Math.pow(holderMatrix.b, 2),
    );
    currentTransform.holder.sy = Math.sqrt(
      Math.pow(holderMatrix.c, 2) + Math.pow(holderMatrix.d, 2),
    );
    currentTransform.holder.w = holder.offsetWidth;
    currentTransform.holder.h = holder.offsetHeight;
    currentTransform.holder.ratio = holder.offsetWidth / holder.offsetHeight;
  }
  return currentTransform;
};
getTransform.propTypes = {
  el: PropTypes.any,
  holder: PropTypes.any,
};

/**
 * Convert style (cssText) to js object
 * @param {*} css
 */
const css2js = css => {
  if (!css) return {};
  let frameCSS = css.replace(/([\w-.]+)\s*:([^;]+);?/g, '$1:$2,');
  frameCSS = frameCSS.replace(/,+$/, '');
  let properties = frameCSS.split(', ');
  let frameCSSObj = {};
  properties.forEach(property => {
    let cssProp = property.split(':');
    let cssKey = cssProp[0].trim();
    let cssValue = cssProp[1].trim();
    frameCSSObj[cssKey] = cssValue;
  });
  return frameCSSObj;
};
css2js.propTypes = {
  css: PropTypes.any,
};

/**
 * Calculate actual position of corner A (top,left)
 * @param {*} targetConfig
 */
const cornerA = targetConfig => {
  const frame = targetConfig.frame;
  const xM = parseFloat(frame.translate[0]);
  const yM = parseFloat(frame.translate[1]);
  const rM = frame.rotate;
  const sM = frame.scale[0];
  const rotate = (rM * Math.PI) / 180;
  const width = targetConfig.holder.w;
  const height = targetConfig.holder.h;
  const xA =
    parseFloat(xM + width / 2 + (width / -2) * (Math.cos(rotate) * sM)) -
    (height / -2) * (Math.sin(rotate) * sM);
  const yA =
    yM +
    height / 2 +
    (width / -2) * (Math.sin(rotate) * sM) +
    (height / -2) * (Math.cos(rotate) * sM);

  return { x: xM, y: yM, xA: xA, yA: yA, rM: rM, sM: sM };
};
cornerA.propTypes = {
  currentTransform: PropTypes.any,
};

/**
 * Calculate actual position of corner A (top,left)
 * Get old position of 'A' corner position and caculate move pixels after
 * calculate new actual position and set to entity
 * @param {*} target
 * @param {*} holder | Holder of content in target
 * @param {*} oldPos | old position of 'A' corner position
 * @param {*} currentPos
 */
const entityNewPos = (target, holder, oldAPos, currentPos, wh) => {
  if (wh) {
    target.style.width = holder.offsetWidth + 'px';
    target.style.height = holder.offsetHeight + 'px';
  }
  const newTransform = {
    frame: {
      translate: [currentPos.tx, currentPos.ty],
      scale: [currentPos.sx, currentPos.sy],
      rotate: currentPos.rotate,
    },
    holder: {
      w: currentPos.holder.w,
      h: currentPos.holder.h,
    },
  };
  const newAPos = cornerA(newTransform);
  const xDiff = newAPos.xA - oldAPos.xA;
  const yDiff = newAPos.yA - oldAPos.yA;
  const newX = parseFloat(newAPos.x - xDiff).toFixed(4);
  const newY = parseFloat(newAPos.y - yDiff).toFixed(4);
  if (target) {
    const transform = `translateX(${newX}px) translateY(${newY}px) rotate(${newAPos.rM}deg) scaleX(${newAPos.sM}) scaleY(${newAPos.sM})`;
    target.style.transform = transform;
    if (holder.style.transform) {
      holder.style.transform = transform;
    }
  } else {
    return {
      tx: newX,
      ty: newY,
      rotate: newAPos.rM,
      scale: newAPos.sM,
    };
  }
};
entityNewPos.propTypes = {
  target: PropTypes.any,
  targetHolder: PropTypes.any,
  oldAPos: PropTypes.any,
  currentPos: PropTypes.any,
};

export { convertId, getTransform, css2js, cornerA, entityNewPos };
